/* ============================================================
   CoolPak — kleine, defensive Komponenten (vanilla JS, ohne Abhängigkeiten)
   1) Mobile Kaufleiste (Produktseite)
   2) Zubehör-Set: Auswahl summieren, gesammelt in den Warenkorb
   Texte und URLs kommen aus window.cpStrings (layout/theme.liquid, Sprachdateien).
   ============================================================ */
(function () {
  "use strict";

  var strings = window.cpStrings || {};
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- 1) Mobile: Kaufleiste einblenden, sobald der echte Button aus dem Bild gescrollt ist ---------- */
  function initStickyBuy() {
    if (window.innerWidth > 749 || !("IntersectionObserver" in window)) return;

    var actions = document.querySelector(".product-actions");
    var addBtn = actions && actions.querySelector('button[name="add"]');
    if (!addBtn || addBtn.disabled) return;

    var priceEl = document.querySelector(".product-info .price .price-item-last") ||
                  document.querySelector(".product-info .price .price-item");
    var title = document.querySelector(".product-info h1");

    var bar = document.createElement("div");
    bar.className = "cp-buybar";

    var info = document.createElement("div");
    info.className = "cp-buybar-info";
    var titleEl = document.createElement("span");
    titleEl.className = "cp-buybar-title";
    titleEl.textContent = title ? title.textContent.trim() : "";
    var priceWrap = document.createElement("span");
    priceWrap.className = "cp-buybar-price";
    priceWrap.textContent = priceEl ? priceEl.textContent.trim() + " " : "";
    var vat = document.createElement("small");
    vat.textContent = strings.vatNote || "";
    priceWrap.appendChild(vat);
    info.appendChild(titleEl);
    info.appendChild(priceWrap);

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "button cp-buybar-btn";
    btn.textContent = strings.addToCart || addBtn.textContent.trim();
    btn.addEventListener("click", function () {
      addBtn.click();
      addBtn.scrollIntoView({ block: "center", behavior: reduceMotion ? "auto" : "smooth" });
    });

    bar.appendChild(info);
    bar.appendChild(btn);
    document.body.appendChild(bar);

    new IntersectionObserver(function (entries) {
      bar.classList.toggle("cp-buybar-show", !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(actions);
  }

  /* ---------- 2) Zubehör-Set: Auswahl summieren, gesammelt in den Warenkorb ---------- */
  function initSet() {
    var box = document.querySelector("[data-cp-set]");
    if (!box) return;

    var boxes = box.querySelectorAll('input[type="checkbox"]');
    var summeEl = box.querySelector("[data-cp-summe]");
    var btn = box.querySelector("[data-cp-add]");
    var msg = box.querySelector("[data-cp-msg]");
    if (!summeEl || !btn || !msg) return;

    function formatEuro(cent) {
      return (cent / 100).toFixed(2).replace(".", ",") + " €";
    }

    function aktualisiere() {
      var summe = 0, anzahl = 0;
      boxes.forEach(function (c) {
        if (c.checked) {
          summe += parseInt(c.dataset.preis, 10) || 0;
          anzahl++;
        }
      });
      summeEl.textContent = anzahl ? formatEuro(summe) : "–";
      btn.disabled = anzahl === 0;
    }

    boxes.forEach(function (c) {
      c.addEventListener("change", aktualisiere);
    });
    aktualisiere();

    btn.addEventListener("click", function () {
      var items = [];
      boxes.forEach(function (c) {
        if (c.checked) items.push({ id: parseInt(c.value, 10), quantity: 1 });
      });
      if (!items.length) return;

      var alterText = btn.textContent;
      btn.disabled = true;
      btn.textContent = strings.setAdding || alterText;
      msg.hidden = true;

      fetch(strings.cartAddUrl || "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error("HTTP " + r.status);
          return r.json();
        })
        .then(function () {
          btn.textContent = strings.setAdded || alterText;
          msg.hidden = false;
          msg.className = "cp-set-note cp-set-ok";
          msg.textContent = (strings.setAddedCount || "").replace("[count]", items.length) + " ";
          var link = document.createElement("a");
          link.href = strings.cartUrl || "/cart";
          link.textContent = strings.setToCart || "";
          msg.appendChild(link);
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          setTimeout(function () {
            btn.textContent = alterText;
            btn.disabled = false;
          }, 2500);
        })
        .catch(function () {
          btn.textContent = alterText;
          btn.disabled = false;
          msg.hidden = false;
          msg.className = "cp-set-note cp-set-err";
          msg.textContent = strings.setError || "";
        });
    });
  }

  function init() {
    initStickyBuy();
    initSet();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
